export const Frontend = {

    moveTo: function(pos) {
        window.setTimeout(function() {
            window.scrollTo( {
                top: pos,
                behavior: 'smooth'
            })
        }, 1);
    },
};

document.addEventListener("DOMContentLoaded", function() {

    window.smoothscroll.polyfill();

    // window.jarallax.jarallax(document.querySelectorAll('[data-jarallax]'), {
    //    imgPosition: '50% 50%',
    //    imgSize: 'cover',
    //    speed: 0.3
    // });

    window.Aos.init({
        once: false,
    });

    /**
     * Hashtag Navigation on Hashchange
     *
     */

    const curHash = location.hash ? location.hash.replace('#', '') : false;
    const hashTarget = document.getElementById(curHash);

    if(curHash && hashTarget) {
        Frontend.moveTo(hashTarget.offsetTop)
    } else {
        Frontend.moveTo(0);
    }

    /**
     * Base Elements needed
     *
     */

    const main = document.getElementById('main') || false;
    const footer = document.getElementById('footer') || false;
    const mainmenu = document.getElementById('canvasNavigation') || false;
    const header = document.getElementById('header') || false;
    const toggler = document.getElementById('mainToggler') || false;
    const revoker = document.getElementById('cookie-revoke-button') || false;
    const swiperdown = document.getElementById('swiper-down') || false;

    /**
     * Load and Resize Listener
     *
     */

    // ['load', 'resize'].forEach(function(e) {
    //     window.addEventListener(e, function() {
    //         main.style.marginBottom = footer.offsetHeight + 'px';
    //     });
    // });

    /**
     * Scroll Listener
     *
     */

    window.addEventListener('scroll', _.throttle(function(e) {
        // let headerSizing = window.scrollY >= header.offsetHeight || false;
        let headerSizing = window.scrollY > 0 || false;
        header ? header.classList.toggle('active', headerSizing) : null;
        swiperdown ? swiperdown.classList.toggle('inactive', headerSizing) : null;
        revoker ? revoker.parentElement.classList.toggle('inactive', headerSizing) : null;
    }, 0));

    /**
     * Mainmenu toggle
     *
     */

    toggler.onclick = function() {
        // mainmenu.style.height = window.innerHeight - header.offsetHeight+'px';
        // mainmenu.style.top = header.offsetHeight+'px';
        // mainmenu.classList.toggle('show');
        // header.classList.toggle('active');
        toggler.classList.toggle('is-active');
        // document.body.classList.toggle('position-fixed');
    };

    /**
     * Lightgallery init
     *
     */

    Array.from(document.getElementsByClassName("lightgallery")).forEach(
        function(element, index, array) {
            lightGallery(element);
        }
    );

    /**
     * Scrollup Arrow Function
     *
     */

    Array.from(document.getElementsByClassName("scrolldown")).forEach(
        function(element, index, array) {
            element.addEventListener('click', function() {
                Frontend.moveTo(window.innerHeight - 80);
            })
        }
    );

    /**
     * Hashtag Navigation from Menu
     *
     */

    Array.from(document.getElementsByClassName("hashed-link")).forEach(
        function(element, index, array) {
            element.addEventListener('click', function(e) {
                e.preventDefault();
                let target = document.getElementById(element.dataset.hashtag.replace("#", ""));
                let others = array.filter(function(nav) {
                    return nav.dataset.hashtag !== element.dataset.hashtag;
                });

                others.forEach(function(e) {
                    e.parentElement.classList.remove('active')
                });

                this.parentElement.classList.add('active');
                mainmenu.classList.remove('show');

                Frontend.moveTo(target.offsetTop - 80);

            });
        }
    );

    /**
     * Toogle Animated Pages Content
     *
     */

    let animatedPagesToggle = document.getElementsByClassName("block-toggle");

    Array.from(animatedPagesToggle).forEach(
        function(element, index, array) {

            let hiddenAosItems = element.nextElementSibling.querySelectorAll('.aos-hidden-item');
            Array.from(hiddenAosItems).forEach(function(e) { e.classList.remove('aos-animate'); });

            element.addEventListener('click', function(e) {
                element.classList.toggle('active');
                element.nextElementSibling.classList.toggle('visible');
                element.nextElementSibling.style.maxHeight = (element.nextElementSibling.classList.contains('visible') ? element.nextElementSibling.scrollHeight : 0) + 'px';
                hiddenAosItems.forEach(function(e) {
                    e.classList.toggle('aos-animate', element.classList.contains('active'));
                });
            });
        }
    );

    /**
     * Toogle Contentblock Content Details
     *
     */

    let detailsToggle = document.querySelectorAll('.details-toggle-icon');

    Array.from(detailsToggle).forEach(
        function(element, index, array) {
            element.addEventListener('click', function(e) {
                let targets = document.querySelectorAll('[data-element="'+element.dataset.targets+'"]');
                let parent = document.getElementById(element.dataset.parent);
                let parents = Array.from(targets).filter(function(e) {
                    return e !== parent;
                });

                parents.forEach(function(e) {
                    e.classList.remove('active');
                });

                parent.classList.toggle('active');

                document.body.classList.toggle('overflow-hidden', parent.classList.contains('active'));
            });
        }
    );
});
